import React, { useEffect, useState } from "react";
import CountUp from "react-countup"; // make sure this is installed
import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";
import { FaUserTie, FaGlobe, FaHandsHelping, FaChalkboardTeacher, FaUniversity, FaChalkboard } from "react-icons/fa";
import CoursesSection from "./CoursesSection";
import MapSvg from "./MapSvg";
import { FaPlane } from "react-icons/fa";
import TestimonialCarousel from "./TestimonialCarousel";
import CplFormModal from "./CplForm";
import FadeInSectionDownToUpDelay from "../../Components/FadeAnimations/Delay/FadeInSectionDownToUpDelay";

const Cpl = () => {
    const [unlocked, setUnlocked] = useState(false);
    const [startCount, setStartCount] = useState(false);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setUnlocked(true);
            setStartCount(true);
        }, 800); // start animation after page load
        return () => clearTimeout(timer);
    }, []);

    const features = [
        {
            icon: <FaUserTie className="text-[#FF6557] text-2xl" />,
            title: "Expert Instructors, Real Experience",
            description:
                "Learn from certified pilots and industry experts who bring real-world flying experience into the classroom and cockpit.",
        },
        {
            icon: <FaGlobe className="text-[#FF6557] text-2xl" />,
            title: "Global Training Options",
            description:
                "Students get the opportunity to train at reputed flying academies across India and abroad, gaining global exposure and world-class learning experiences that prepare them for an international aviation career.",
        },
        {
            icon: <FaHandsHelping className="text-[#FF6557] text-2xl" />,
            title: "Personalized Support",
            description:
                "With a limited student intake, we ensure every trainee receives dedicated guidance, one-on-one mentorship, and the attention needed to excel in both flying and academics.",
        },
        {
            icon: <FaChalkboardTeacher className="text-[#FF6557] text-2xl" />,
            title: "Smart Learning with LMS",
            description:
                "Gain access to our dedicated Learning Management System, where students can track progress, review study material, and stay connected with instructors for a smarter way to learn.",
        },
        {
            icon: <FaUniversity className="text-[#FF6557] text-2xl" />,
            title: "Integrated Degree + CPL Program",
            description:
                "Combine an academic qualification with a Commercial Pilot License, creating a strong backup career path while opening doors to wider job opportunities in aviation and beyond.",
        },
        {
            icon: <FaChalkboard className="text-[#FF6557] text-2xl" />,
            title: "Available in Offline Classes",
            description:
                "Experience face-to-face learning with expert instructors, hands-on guidance, and real-time interactions that bring clarity and confidence to your aviation training.",
        },
    ];

    // const courses = [
    //     {
    //         title: "Commercial Pilot License (CPL)",
    //         img: "https://images.unsplash.com/photo-1508614999368-9260051291ea?auto=format&fit=crop&w=600&q=80",
    //     },
    //     {
    //         title: "Private Pilot License (PPL)",
    //         img: "https://images.unsplash.com/photo-1518655048521-f130df041f66?auto=format&fit=crop&w=600&q=80",
    //     },
    //     {
    //         title: "Airline Transport Pilot License (ATPL)",
    //         img: "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=600&q=80",
    //     },
    //     {
    //         title: "Type Rating",
    //         img: "https://images.unsplash.com/photo-1485841890310-6a055c88698a?auto=format&fit=crop&w=600&q=80",
    //     },
    // ];

    const countries = [
        { name: "INDIA", duration: "13–15 MONTHS" },
        { name: "UAE", duration: "12–15 MONTHS" },
        { name: "USA", duration: "10–12 MONTHS" },
        { name: "GREECE", duration: "12–15 MONTHS" },
        { name: "NZ", duration: "10–13 MONTHS" },
        { name: "CANADA", duration: "12–18 MONTHS" },
        { name: "SOUTH AFRICA", duration: "13–15 MONTHS" },
        { name: "AUS", duration: "10–13 MONTHS" },
    ];

    return (
        <div>
            <div
                className="relative h-screen w-full bg-cover bg-center flex flex-col items-center justify-start"
                style={{
                    backgroundImage:
                        "url('https://mhcockpit.com/Media/Home/Converted/Heropage/mh-cockpit-aviation-training-academy.webp')",
                }}
            >
                {/* Overlay */}
                <div className="absolute inset-0 bg-black/50"></div>

                {/* Content */}
                <div className="relative z-10 flex flex-col items-center text-center mt-10 max-sm:mt-5 px-4 space-y-5">
                    {/* Title with custom "Unlock" animation */}
                    <FadeInSectionDownToUpDelay delay="400ms">
                        <h1 className="text-white text-3xl md:text-5xl font-bold leading-snug">
                            <span className="flex max-sm:inline-block">
                                <span className="flex items-end max-sm:items-center max-sm:justify-center">
                                    Unl
                                    {/* Custom Cylinder Toggle as "O" */}
                                    <span className="relative w-12 h-6 rounded-full bg-white overflow-hidden">
                                        <span
                                            className={`absolute top-0.5 w-5 h-5 bg-[#FF6557] rounded-full transition-all duration-700 ${unlocked ? "left-6" : "left-0.5"
                                                }`}
                                        ></span>
                                    </span>
                                    ck
                                </span>
                                <span className="pl-3"> World-Class Aviation</span>
                            </span>
                            <span className="block mt-1">
                                Training With <span className="text-[#FF6557]">MH Cockpit</span>
                            </span>
                        </h1>
                    </FadeInSectionDownToUpDelay>

                    {/* Description */}
                    <FadeInSectionDownToUpDelay delay="600ms">
                        <p className="max-w-2xl text-base md:text-lg text-gray-200 leading-relaxed">
                            Here’s your chance to unlock the skies with our CPL training
                            program designed to give you world-class flying skills, hands-on
                            experience, and the confidence to take your aviation career to new
                            heights.
                        </p>
                    </FadeInSectionDownToUpDelay>

                    {/* CTA Button */}
                    <FadeInSectionDownToUpDelay delay="800ms">
                        <button onClick={() => setOpen(true)} className="px-6 py-3 bg-white font-semibold rounded-lg shadow-lg transition">
                            Apply Now
                        </button>
                    </FadeInSectionDownToUpDelay>
                </div>

                {/* Bottom Right Stats Section with Glassy Background */}
                <div className="absolute bottom-6 right-6 max-sm:right-0 max-sm:left-0 w-1/2 xl:w-1/2 sm:w-3/4 max-sm:w-full max-sm:px-5">
                    <div className="grid grid-cols-3 gap-5 p-6 rounded-2xl bg-white/10 backdrop-blur-lg border border-white/20 shadow-xl">
                        <div className="flex flex-col items-center">
                            <FadeInSectionDownToUp>
                                <p className="text-4xl max-sm:text-3xl font-semibold text-white">
                                    {startCount && <CountUp end={95} duration={2} suffix="%" />}
                                </p>
                                <p className="text-xl max-sm:text-sm text-gray-200">
                                    Success Rate
                                </p>
                            </FadeInSectionDownToUp>
                        </div>
                        <div className="flex flex-col items-center">
                            <FadeInSectionDownToUp>
                                <p className="text-4xl max-sm:text-3xl font-semibold text-white">
                                    {startCount && <CountUp end={1000} duration={2} suffix="+" />}
                                </p>
                                <p className="text-xl max-sm:text-sm text-gray-200">
                                    Successful Pilots Trained
                                </p>
                            </FadeInSectionDownToUp>
                        </div>
                        <div className="flex flex-col items-center">
                            <FadeInSectionDownToUp>
                                <p className="text-4xl max-sm:text-3xl font-semibold text-white">
                                    {startCount && <CountUp end={250} duration={2} suffix="+" />}
                                </p>
                                <p className="text-xl max-sm:text-sm text-gray-200">
                                    Average Flying Experience per Student
                                </p>
                            </FadeInSectionDownToUp>
                        </div>
                    </div>
                </div>
            </div>
            <section className="w-full py-16 bg-gray-50">
                <div className="container mx-auto flex flex-col lg:flex-row items-start gap-12 px-6">

                    {/* Left Heading Section */}
                    <div className="w-full lg:w-1/3 flex flex-col items-start">
                        <FadeInSectionDownToUp>
                            <div className="flex items-center mb-4">
                                <span className="w-10 h-[2px] bg-[#FF6557] mr-3"></span>
                                <span className="text-[#FF6557] font-semibold uppercase tracking-wide">
                                    WHY CHOOSE MH COCKPIT ?
                                </span>
                            </div>
                        </FadeInSectionDownToUp>

                        <FadeInSectionDownToUp>
                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
                                Discover Why MH Cockpit Is the{" "}
                                <span className="text-[#FF6557]">Smart Choice</span> for Aviation Training
                            </h2>
                        </FadeInSectionDownToUp>
                    </div>

                    {/* Right Content - Features */}
                    <div className="w-full lg:w-2/3">
                        <div className="grid grid-cols-3 xl:grid-cols-3 sm:grid-cols-2 max-sm:grid-cols-1 gap-10">
                            {features.map((feature, index) => (
                                <FadeInSectionDownToUp key={index}>
                                    <div className="flex items-start gap-4">
                                        <div className="flex-shrink-0">{feature.icon}</div>
                                        <div>
                                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                                {feature.title}
                                            </h3>
                                            <p className="text-gray-600 text-sm leading-relaxed">
                                                {feature.description}
                                            </p>
                                        </div>
                                    </div>
                                </FadeInSectionDownToUp>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <section className="w-full py-16 bg-white">
                <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 px-6">
                    <div className="w-full lg:w-1/2">
                        <FadeInSectionDownToUp>
                            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                                Courses That Take You Higher
                            </h2>
                        </FadeInSectionDownToUp>
                        <FadeInSectionDownToUp>
                            <p className="text-gray-600 text-lg leading-relaxed">
                                Explore our professional pilot training programs designed to take you
                                from first flight to full certification.
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                    <div className="w-full lg:w-1/2 flex items-center justify-center">
                        <div className="relative w-full flex items-center">
                            <div className="border-t-2 border-dotted border-gray-400 w-full"></div>
                            {/* <FaArrowRight className="absolute right-0 text-[#FF6557] text-2xl" /> */}
                            <FaPlane className="absolute right-0 text-2xl text-[#FF6557]" />
                        </div>
                    </div>
                </div>
                {/* <div
                    className="py-12 px-6 bg-cover bg-center"
                >
                    <div className="rounded-2xl p-8"
                        style={{
                            backgroundImage:
                                "url('https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80')",
                        }}
                    >
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                            {courses.map((course, index) => (
                                <FadeInSectionDownToUp key={index}>
                                    <div className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full hover:scale-105 transition-transform duration-300 p-5">
                                        <img
                                            src={course.img}
                                            alt={course.title}
                                            className="w-full h-48 object-cover rounded-xl"
                                        />
                                        <div className="p-4 flex-grow flex items-center justify-center">
                                            <h3 className="text-lg font-semibold text-center text-gray-800">
                                                {course.title}
                                            </h3>
                                        </div>
                                    </div>
                                </FadeInSectionDownToUp>
                            ))}
                        </div>
                    </div>
                </div> */}
            </section>
            <div>
                <CoursesSection />
            </div>
            <div>
                <MapSvg />
            </div>
            <div className="px-20 max-sm:px-5">
                <div className="w-full bg-[#28536B] py-6 px-4 rounded-xl">
                    <div className="space-y-5">

                        {/* Countries */}
                        {/* <div className="flex flex-wrap justify-center gap-8 z-10">
                            {countries.map((item, index) => (
                                <FadeInSectionDownToUpDelay delay="500ms">
                                    <div
                                        key={index}
                                        className="flex flex-col text-white min-w-[100px] space-x-10 max-sm:space-x-0"
                                    >
                                        <div className="flex gap-2">
                                            <FaPlane className="text-xl animate-pulse -rotate-45" />
                                            <p className="text-xl font-semibold">{item.name}</p>
                                        </div>
                                        <p className="text-xs mt-1">{item.duration}</p>
                                    </div>
                                </FadeInSectionDownToUpDelay>
                            ))}
                        </div> */}

                        <div className="flex flex-wrap justify-center gap-8 z-10">
                            {countries.map((item, index) => (
                                <FadeInSectionDownToUpDelay key={index} delay={`${index * 100}ms`}>
                                    <div className="flex flex-col text-white min-w-[100px] space-x-10 max-sm:space-x-0">
                                        <div className="flex gap-2">
                                            <FaPlane className="text-xl animate-pulse -rotate-45" />
                                            <p className="text-xl font-semibold">{item.name}</p>
                                        </div>
                                        <p className="text-xs mt-1">{item.duration}</p>
                                    </div>
                                </FadeInSectionDownToUpDelay>
                            ))}
                        </div>
                        {/* Dashed Line */}
                        <div className="flex items-center mx-40 max-sm:mx-5">
                            <div className="bg-white p-1 rounded-full" />
                            {/* <FaPlane className="text-xl text-white animate-pulse" /> */}
                            <div className="border-t border-dashed border-white w-full" />
                            <div className="bg-white p-1 rounded-full" />
                            {/* <FaPlane className="text-xl text-white animate-pulse" /> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="py-20 max-sm:py-10">
                <TestimonialCarousel />
            </div>
            <section className="px-10 max-sm:px-5 py-10">
                {/* Heading */}
                <div className="text-center max-w-3xl mx-auto mb-10">
                    <h2 className="text-2xl md:text-3xl font-bold mb-4">Gallery</h2>
                    <p className="text-gray-600 text-sm md:text-base">
                        Take a glimpse into life at MH Cockpit our aircraft, simulators,
                        classrooms, and the memorable moments that shape every pilot’s journey.
                    </p>
                </div>

                <div>
                    <img className="w-full" src="https://mhcockpit.com/Media/Landing/CPL/gall-grid-2.jpg" alt="CPL Gallery" />
                </div>

                {/* Grid */}
                {/* <div className="flex justify-center items-center gap-4 w-full">
                    <div className="space-y-4 w-full">
                        <div>
                            <img
                                src="https://i.ibb.co/n0hmz8x/classroom.jpg"
                                alt="Classroom"
                                className="w-full h-full object-cover rounded-lg"
                            />
                        </div>
                        <div>
                            <img
                                src="https://i.ibb.co/n0hmz8x/classroom.jpg"
                                alt="Classroom"
                                className="w-full h-full object-cover rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="w-full">
                        <div>
                            <img
                                src="https://i.ibb.co/n0hmz8x/classroom.jpg"
                                alt="Classroom"
                                className="w-full h-full object-cover rounded-lg"
                            />
                        </div>
                    </div>
                    <div className="space-y-4 w-full">
                        <div className="flex gap-4">
                            <div>
                                <img
                                    src="https://i.ibb.co/n0hmz8x/classroom.jpg"
                                    alt="Classroom"
                                    className="w-full h-full object-cover rounded-lg"
                                />
                            </div>
                            <div>
                                <img
                                    src="https://i.ibb.co/n0hmz8x/classroom.jpg"
                                    alt="Classroom"
                                    className="w-full h-full object-cover rounded-lg"
                                />
                            </div>
                        </div>
                        <div>
                            <img
                                src="https://i.ibb.co/n0hmz8x/classroom.jpg"
                                alt="Classroom"
                                className="w-full h-full object-cover rounded-lg"
                            />
                        </div>
                    </div>
                </div> */}

                {/* CTA */}
                <div className="text-center mt-10">
                    <p className="text-gray-800 font-medium mb-6">
                        The skies won’t wait hurry up !!! and start your journey
                        <br />
                        with MH Cockpit.
                    </p>
                    <div className="flex justify-center gap-4">
                        <button onClick={() => setOpen(true)} className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition">
                            Apply Now
                        </button>
                        {/* <button className="px-6 py-2 border border-black text-black rounded-lg hover:bg-black hover:text-white transition">
                            In Query
                        </button> */}
                    </div>
                </div>
            </section>
            {/* Form Modal */}
            <div>
                <CplFormModal open={open} onClose={() => setOpen(false)} />
            </div>
            {/* <div class="grid grid-cols-4 md:grid-cols-8 grid-rows-4 md:grid-rows-1 gap-2 md:gap-2 m-4">
                <div class="col-start-1 row-start-1 row-span-2 md:col-start-1 md:row-start-1 md:col-span-2 md:row-span-1">
                    <img src="https://mhcockpit.com/Media/Gallery/(117).webp" alt="Image 0" class="w-full h-full object-cover rounded-md" />
                </div>

                <div class="col-start-1 row-start-3 row-span-2 md:col-start-1 md:row-start-3 md:col-span-2 md:row-span-1">
                    <img src="https://mhcockpit.com/Media/Gallery/%20%20(12).webp" alt="Image 1" class="w-full h-full object-cover rounded-md" />
                </div>

                <div class="col-start-2 row-start-1 row-span-4 md:col-start-3 md:row-start-1 md:col-span-3 md:row-span-3">
                    <img src="https://mhcockpit.com/Media/Gallery/(120).webp" alt="Image 2" class="w-full h-full object-cover rounded-md" />
                </div>

                <div class="col-start-3 row-start-1 row-span-2 md:col-start-6 md:row-start-1 md:col-span-1 md:row-span-1">
                    <img src="https://mhcockpit.com/Media/Gallery/%20%20(6).webp" alt="Image 3" class="w-full h-full object-cover rounded-md" />
                </div>

                <div class="col-start-4 row-start-1 row-span-2 md:col-start-7 md:row-start-1 md:col-span-2 md:row-span-1">
                    <img src="https://mhcockpit.com/Media/Gallery/%20%20(15).webp" alt="Image 4" class="w-full h-full object-cover rounded-md" />
                </div>

                <div class="col-start-3 row-start-3 col-span-2 row-span-2 md:col-start-6 md:row-start-3 md:col-span-3 md:row-span-1">
                    <img src="https://mhcockpit.com/Media/Gallery/%20%20(9).webp" alt="Image 5" class="w-full h-full object-cover rounded-md" />
                </div>
            </div> */}

        </div>
    );
};

export default Cpl;
